/* tslint:disable */
/* eslint-disable */
/**
 * Your Project API
 * Your project description
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    Project,
    ProjectFromJSON,
    ProjectFromJSONTyped,
    ProjectToJSON,
} from './';

/**
 * 
 * @export
 * @interface PaginatedProjectList
 */
export interface PaginatedProjectList {
    /**
     * 
     * @type {number}
     * @memberof PaginatedProjectList
     */
    count?: number;
    /**
     * 
     * @type {string}
     * @memberof PaginatedProjectList
     */
    next?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaginatedProjectList
     */
    previous?: string | null;
    /**
     * 
     * @type {Array<Project>}
     * @memberof PaginatedProjectList
     */
    results?: Array<Project>;
}

export function PaginatedProjectListFromJSON(json: any): PaginatedProjectList {
    return PaginatedProjectListFromJSONTyped(json, false);
}

export function PaginatedProjectListFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaginatedProjectList {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'count': !exists(json, 'count') ? undefined : json['count'],
        'next': !exists(json, 'next') ? undefined : json['next'],
        'previous': !exists(json, 'previous') ? undefined : json['previous'],
        'results': !exists(json, 'results') ? undefined : ((json['results'] as Array<any>).map(ProjectFromJSON)),
    };
}

export function PaginatedProjectListToJSON(value?: PaginatedProjectList | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'count': value.count,
        'next': value.next,
        'previous': value.previous,
        'results': value.results === undefined ? undefined : ((value.results as Array<any>).map(ProjectToJSON)),
    };
}

